<template>
    <div v-if="isModalVisible" class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
        id="popup-content" @click.self="closeModal">
        <div class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto">
            <div class="shadow-none bg-transparent">
                <div class="flex items-start justify-between">
                    <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
                        {{ selectedDistributor.name }}
                    </p>
                    <button class="text-2xl text-[#353535] outline-none focus:outline-none" type="button"
                        @click="closeModal">
                        <span class="mdi mdi-close"></span>
                    </button>
                </div>
                <div class="bg-white p-1 rounded-[4px] flex items-center gap-[16px] mt-[16px]">
                    <button :class="[
                        'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px] outline-none focus:outline-none',
                        {
                            'bg-[#2463EB] text-white': activeTab === 'profile',
                            'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'profile',
                        },
                    ]" @click="switchTab('profile')">
                        Profile
                    </button>
                    <div v-if="
                        hasPermission('Distributor_Product_Permission_View') ||
                        hasPermission('Distributor_Product_Permission_Update')
                    ">
                        <button :class="[
                            'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px] outline-none focus:outline-none',
                            {
                                'bg-[#2463EB] text-white': activeTab === 'settings',
                                'bg-[#f8f8f8] text-[#96a0b5]': activeTab !== 'settings',
                            },
                        ]" @click="switchTab('settings')" v-if="
                            hasPermission('Distributor_Product_Permission_Update') &&
                            hasPermission('Price_Option_View')
                        ">
                            Additional Settings
                        </button>
                    </div>
                </div>
                <div v-if="activeTab === 'profile'">
                    <div class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]">
                        <div
                            class="flex flex-col xl:flex-row justify-between items-start gap-[5px] xl:items-center xl:gap-[10px]">
                            <div class="flex items-center gap-2 flex-1">
                                <h2
                                    class="font-semibold text-[20px] leading-[20px] text-[#353535] md:max-w-[170px] w-full">
                                    Business Profile
                                </h2>
                                <span class="flex items-center gap-[4px] max-w-max w-full" :class="[
                                    'badge',
                                    {
                                        'badge-success': selectedDistributor.isOnboarded,
                                        'badge-danger': !selectedDistributor.isOnboarded,
                                    },
                                ]">
                                    <span class="w-[10px] h-[10px] rounded-[1px]" :style="{
                                        backgroundColor: selectedDistributor.isOnboarded
                                            ? '#16a249'
                                            : '#EF5253',
                                    }"></span>
                                    <span class="text-[12px] font-normal">{{
                                        selectedDistributor.isOnboarded ? "Active" : "Inactive"
                                    }}</span>
                                </span>
                            </div>
                            <div class="flex flex-1 gap-[10px] justify-end">
                                <button @click="checkBalance"
                                    class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-medium text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none">
                                    Distributor's Balance
                                </button>
                                <button @click="refreshDistributor"
                                    class="text-[#96a0b5] text-[14px] font-normal bg-[#2463EB] text-white py-[12px] px-[24px] rounded-[8px] outline-none focus:outline-none">
                                    {{ isLoading ? "Loading..." : "Refresh Data" }}
                                </button>
                                <button class="bg-[#2463EB] py-[12px] px-[24px] rounded-[8px]" v-if="
                                    !selectedDistributor.isOnboarded &&
                                    hasPermission('Distributor_Send_Invite')
                                " @click.prevent="resendInvite">
                                    <span v-if="sendingInvite"
                                        class="text-white text-[14px] text-[#96a0b5] font-normal">Busy...</span>
                                    <span class="text-white text-[14px] text-[#96a0b5] font-normal" v-else>Send
                                        Registration</span>
                                </button>
                            </div>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">Business Name
                            </h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.name }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">SAP Status
                            </h2>
                            <span class="flex items-center gap-[4px] max-w-max w-full" :class="[
                                'badge',
                                {
                                    'badge-success': selectedDistributor.active,
                                    'badge-danger': !selectedDistributor.active,
                                },
                            ]">
                                <span class="w-[10px] h-[10px] rounded-[1px]" :style="{
                                    backgroundColor: selectedDistributor.active
                                        ? '#16a249'
                                        : '#EF5253',
                                }"></span>
                                <span class="text-[12px] font-normal">{{
                                    selectedDistributor.active ? "Active" : "Inactive"
                                }}</span>
                            </span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">RC Number</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.rcNumber }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">Business
                                Description</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.description ? selectedDistributor.description : "N/A"
                            }}</span>
                        </div>
                        <div v-if="selectedDistributor.website"
                            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">Website</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.website ? selectedDistributor.website : "N/A"
                            }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">Business Phone
                                Number</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">+{{
                                selectedDistributor.phoneNumber ? selectedDistributor.phoneNumber : "Not Available"
                            }}</span>
                        </div>
                        <div v-if="selectedDistributor.tin"
                            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">Tax
                                Identification Number</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.tin ? selectedDistributor.tin : "N/A"
                            }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">Business Email
                                Address</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.businessEmailAddress ? selectedDistributor.businessEmailAddress :
                                    "Not Available"
                            }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] md:max-w-[170px] w-full">Business Address
                            </h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.address1 }}
                                {{ selectedDistributor.address2 }} {{ selectedDistributor.city }}</span>
                        </div>
                    </div>

                    <div class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]">
                        <h2 class="font-semibold text-[20px] leading-[20px] text-[#353535]">System Information</h2>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">Code</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.code }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">State</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.state }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">
                                Sales Group
                            </h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.sapSalesGroup ? selectedDistributor.sapSalesGroup : "--" }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">Tax Classification
                            </h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.sapTaxClassification }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">Price Group</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.sapPriceGroup ? selectedDistributor.sapPriceGroup : "--" }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">Created</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                formatDate(selectedDistributor.created) }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">Primary Email</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.emailAddress }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[170px] w-full">Last Updated</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                formatDate(selectedDistributor.updated) }}</span>
                        </div>
                    </div>

                    <div class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]">
                        <h2 class="font-semibold text-[20px] leading-[20px] text-[#353535]">Contact Information</h2>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[200px] w-full">Contact Person Name
                            </h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.name }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[200px] w-full">Email Address</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.businessEmailAddress ? selectedDistributor.businessEmailAddress :
                                    "Not Available"
                            }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[200px] w-full">Phone Number</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">+{{
                                selectedDistributor.phoneNumber ? selectedDistributor.phoneNumber : "Not Available"
                            }}</span>
                        </div>
                    </div>

                    <div class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]">
                        <h2 class="font-semibold text-[20px] leading-[20px] text-[#353535]">Bank Information</h2>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[200px] w-full">Bank</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.bank.name }}</span>
                        </div>
                        <div class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2">
                            <h2 class="font-normal text-[16px] text-[#96a0b5] max-w-[200px] w-full">Account Number</h2>
                            <span class="font-medium text-[16px] text-[#353535] leading-[19.36px]">{{
                                selectedDistributor.bank.accountNumber }}</span>
                        </div>
                    </div>
                </div>

                <div v-if="activeTab === 'settings'"
                    class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]">
                    <div class="w-full flex justify-start items-start gap-[16px]">
                        <h2 :class="[
                            'text-[14px] font-semibold leading-[20px] cursor-pointer',
                            {
                                'border-b-2 border-[#2463EB] text-[#2463EB] pb-[5px]': activeSubTab === 'priceAssociation',
                                'text-[#96a0b5]': activeSubTab !== 'priceAssociation',
                            },
                        ]" @click="switchSubTab('priceAssociation')">
                            Price Association
                        </h2>
                        <h2 :class="[
                            'text-[14px] font-semibold leading-[20px] cursor-pointer',
                            {
                                'border-b-2 border-[#2463EB] text-[#2463EB] pb-[5px]': activeSubTab === 'productCatalogue',
                                'text-[#96a0b5]': activeSubTab !== 'productCatalogue',
                            },
                        ]" @click="switchSubTab('productCatalogue')">
                            Product Catalogue Permissions
                        </h2>
                    </div>

                    <div v-if="activeSubTab === 'priceAssociation'">
                        <div class="table-responsive mt-6">
                            <table class="table p-0 m-0 dataTable no-footer">
                                <thead class="bg-white">
                                    <tr class="py-[5px]">
                                        <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Product Code
                                        </th>
                                        <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Product Name
                                        </th>
                                        <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Distributor
                                            Price</th>
                                        <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Recommended
                                            Retail Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="op in priceOptions" :key="op.id">
                                        <td class="text-[14px] font-normal leading-[16.94px]">{{ op.product.code }}</td>
                                        <td class="text-[14px] font-normal leading-[16.94px]">{{ op.product.name }}</td>
                                        <td class="text-[14px] font-normal leading-[16.94px]">₦ {{
                                            formatMoney(op.product.distributorPrice) }}</td>
                                        <td class="text-[14px] font-normal leading-[16.94px]">₦ {{
                                            formatMoney(op.product.retailPrice) }}</td>
                                    </tr>
                                    <tr v-if="!priceOptions.length">
                                        <td colspan="7">
                                            <div class="text-center" style="padding-top: 50px"></div>
                                            <h3 class="text-center pt-[32px] text-[14px] font-normal leading-[16.94px]"
                                                style="padding-bottom: 100px">
                                                There are no price options associated with this distributor
                                            </h3>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div v-if="activeSubTab === 'productCatalogue'">
                        <div class="mt-6">
                            <div class="w-full pb-[24px] border-b border-[#EAECF0]">
                                <div class="max-w-[500px] w-full flex items-center gap-[16px]">
                                    <select
                                        class="border border-[#D0D5DD] px-[14px] py-[12px] rounded-[8px] w-full text-[#96A0B5] outline-none custom-select custom-select-lg">
                                        <option disabled selected>Select Permissions</option>
                                        <option>No Restriction</option>
                                        <option>Only Sell My Product</option>
                                        <option>Only Sell Their Product</option>
                                    </select>
                                    <button
                                        class="text-[#96a0b5] text-[14px] font-normal bg-[#2463EB] text-white py-[12px] px-[24px] rounded-[8px] cursor-pointer">
                                        Update
                                    </button>
                                </div>
                            </div>
                            <div class="mt-[24px] w-full">
                                <h2 class="font-semibold text-[18px] leading-[24px] text-[#353535] w-full">Product
                                    Catalogue Settings</h2>
                                <div class="max-w-[400px] w-full mt-[24px]">
                                    <label for="permission"
                                        class="text-[16px] leading-[24px] font-medium text-[#353535]">Product
                                        Permission</label>
                                    <br />
                                    <select id="permission"
                                        class="border border-[#D0D5DD] px-[14px] py-[12px] rounded-[8px] w-full text-[#96A0B5] outline-none custom-select custom-select-lg">
                                        <option disabled selected>Select Permissions</option>
                                        <option>Only Sell My Product</option>
                                        <option>Only Sell Their Product</option>
                                    </select>
                                </div>
                                <div class="max-w-[400px] w-full mt-[16px]">
                                    <label for="price"
                                        class="text-[16px] leading-[24px] font-medium text-[#353535]">Product Price
                                        Options View</label>
                                    <br />
                                    <select id="price"
                                        class="border border-[#D0D5DD] px-[14px] py-[12px] rounded-[8px] w-full text-[#96A0B5] outline-none custom-select custom-select-lg">
                                        <option disabled selected>Select Permissions</option>
                                        <option>No Restriction</option>
                                        <option>Yes</option>
                                        <option>No</option>
                                    </select>
                                </div>
                                <button
                                    class="text-[#96a0b5] text-[14px] mt-[16px] font-normal bg-[#2463EB] text-white py-[12px] px-[24px] rounded-[8px] cursor-pointer">
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SystemPermissions from "@/permissions";
import moment from "moment";
import { helper } from "@/helper";

export default {
    mixins: [SystemPermissions.Mixin],
    props: {
        isModalVisible: Boolean,
        selectedDistributor: Object,
    },
    data() {
        return {
            sendingInvite: false,
            isBusy: false,
            activeTab: "profile",
            activeSubTab: "priceAssociation",
            priceOptions: [],
            isLoading: false,
        };
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        switchTab(tab) {
            this.activeTab = tab;
        },
        switchSubTab(subTab) {
            this.activeSubTab = subTab;
        },
        async checkBalance() {
            this.$emit('check-balance');
        },
        async refreshDistributor() {
            this.isLoading = true;
            try {
                await this.$http.get("/Accounts/refreshSapPartner", {
                    params: { accountId: this.selectedDistributor.id },
                });
                this.$toast.success("Distributor refreshed successfully!", {
                    icon: true,
                    rtl: false,
                });
                this.closeModal();
            } catch (error) {
                console.error("Failed to refresh distributor:", error);
            } finally {
                this.isLoading = false;
            }
        },
        async resendInvite() {
            try {
                this.sendingInvite = true;
                const res = await this.$http.post(`/Accounts/inviteSapPartnerUser`, {
                    customerCode: this.selectedDistributor.code,
                    businessName: this.selectedDistributor.name,
                    accountId: this.selectedDistributor.id,
                });
                if (res) {
                    this.closeModal();
                    this.$toast.success(res.message || "Invite sent successfully", {
                        icon: true,
                        rtl: false,
                    });
                }
            } catch (error) {
                console.log(error);
                this.closeModal();
                this.$toast.error("Failed to send invite", {
                    icon: true,
                    rtl: false,
                });
            } finally {
                this.sendingInvite = false;
            }
        },
        formatDate(date) {
            return moment(date).format("ll");
        },
        formatMoney(val) {
            return helper.formatMoney(val);
        },
    },
};
</script>

<style scoped>
#popup-content::-webkit-scrollbar {
    width: 0.1px;
    height: 5px;
}

#popup-content::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}

#popup-content::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
}

#popup-content::-webkit-scrollbar-thumb:hover {
    background-color: #55555563;
}
</style>